import * as React from 'react';
import { TranslationContextProvider } from './TranslationContext';
import { ConfigContextProvider } from './ConfigContext';
import {TranslationKeysLister} from './TranslationKeysLister';
import {MainComponent} from './MainComponent';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import './css/normalize.css';
import './css/webflow.css';
import './css/webflow_carsim.css';
import './css/carsim.css';


export default function App() {
  return (
      <ConfigContextProvider>
        <TranslationContextProvider>
          <ToastContainer />
          <MainComponent/>
      </TranslationContextProvider>
    </ConfigContextProvider>
  );
}
